import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IRenewalDataFormMeta {
    automaticRenewal: FormInputMeta;
    renewalDate: FormInputMeta;
    newEffectiveDate: FormInputMeta;
    newExpirationDate: FormInputMeta;

    schema: any;
}

const renewalDataFormMeta = {} as IRenewalDataFormMeta;

renewalDataFormMeta.automaticRenewal = {
    name: "automaticRenewal",
    type: "checkbox",
    label: "Renouvel. Automatique",
    placeholder: "",
    validation: yup.boolean()
};

renewalDataFormMeta.renewalDate = {
    name: "renewalDate",
    type: "date",
    label: "Date Renouv.",
    placeholder: "",
    validation: yup.date().notRequired()
};

renewalDataFormMeta.newEffectiveDate = {
    name: "newEffectiveDate",
    type: "date",
    label: "Nouv. Date Effective",
    placeholder: "",
    validation: yup.date().notRequired()
};

renewalDataFormMeta.newExpirationDate = {
    name: "newExpirationDate",
    type: "date",
    label: "Nouv. Date Expi.",
    placeholder: "",
    validation: yup.date().notRequired()
};


renewalDataFormMeta.schema = yup.object().shape(getValidationSchema(renewalDataFormMeta));

export default renewalDataFormMeta;